"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3248],{

/***/ 33248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _context_useStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80094);





var Price = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 1608).then(__webpack_require__.bind(__webpack_require__, 21608));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21608)
            ];
        }
    },
    suspense: true
});
var Cover = function(param) {
    var alt = param.alt, src = param.src, ListPrice = param.ListPrice, Lock = param.Lock;
    var auth = (0,_context_useStore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(state) {
        return state.auth;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative w-full aspect-[310/200]",
        children: [
            auth.login === false && Lock === true && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute w-full h-full top-0 right-0 z-[5] flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rounded-md bg-black text-white bg-opacity-80 px-5 py-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-base font-medium",
                        children: "Login Required"
                    })
                })
            }),
            auth.login === true && Lock === true && auth.verify == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute w-full h-full top-0 right-0 z-[5] flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rounded-md bg-black text-white bg-opacity-80 px-5 py-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-sm font-medium",
                        children: "Please Click Here To Verify Your Account"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Loading..."
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: src,
                    alt: alt,
                    className: "object-cover w-full h-full ".concat(auth.login === false && Lock === true || auth.login === true && Lock === true && auth.verify === false ? "blur" : ""),
                    sizes: "(min-width: 1280px) 25vw, (min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Price, {
                    blur: auth.login === false && Lock === true ? true : auth.login === true && Lock === true && auth.verify == false ? true : false,
                    ListPrice: ListPrice
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Cover);


/***/ })

}]);